import { Text } from "@mantine/core"

export const Asterisk = () => {
  return (
    <Text c="red" span>
      *
    </Text>
  )
}
